export enum GenericTileStatus {
  Started = 0,
  Incomplete = 1,
  Rejected = 2,
  Valid = 3,
  Handling = 4,
}

/**
 * Backend intends to provide a simplified status enum in the future
 */
export enum ApplicationStatus {
  Start = 'Start',
  Draft = 'Draft',
  Payment = 'Payment',
  CheckQualification = 'CheckQualification',
  Approved = 'Approved',
  // TODO: Rejected not currently supported in backend
  Rejected = 'Rejected',
  ManualProcessing = 'ManualProcessing',
  RequestMoreInformation = 'RequestMoreInformation',
  QASample = 'QASample',
  CreateCertificate = 'CreateCertificate',
  Archive = 'Archive',
  Final = 'Final',
  Done = 'Done',
  RequestMoreInformationTimedOut = 'RequestMoreInformationTimedOut',
}

export enum ApplicationProgress {
  Setup = 'Setup',
  Processing = 'Processing',
  Approved = 'Approved',
  Rejected = 'Rejected',
  QASample = 'QASample',
}

export enum CertificatePrintLanguage {
  NorwegianNynorsk = 'nn',
  NorwegianBokmal = 'no',
  English = 'en',
}

export enum CertificatePrintStatus {
  NotStarted = 'NotStarted',
  Started = 'Started',
  Ok = 'Ok',
  Error = 'Error',
}

export enum SimplifiedApplicationStatus {
  Setup = 'Setup',
  AwaitingPayment = 'AwaitingPayment',
  Processing = 'Processing',
  MoreInfoRequested = 'MoreInfoRequested',
  Approved = 'Approved',
  Rejected = 'Rejected',
  RejectedNotPaid = 'RejectedNotPaid',
  Processed = 'Processed',
}

/**
 * Enum type for TopBraid qualification types
 * TODO: update to match actual
 */
export enum QualificationType {
  Education = 'https://www.sdir.no/SDIR_Simulator#EducationProperties',
  Course = 'https://www.sdir.no/SDIR_Simulator#CourseProperties',
  SeagoingTime = 'https://www.sdir.no/SDIR_Simulator#SeagoingServiceProperties',
  Health = 'https://www.sdir.no/SDIR_Simulator#HealthCertificateProperties',
  Certificate = 'https://www.sdir.no/SDIR_Simulator#CertificateProperties',
  Assessment = 'https://www.sdir.no/SDIR_Simulator#AssessmentProperties',
  AdditionalCompetence = 'https://www.sdir.no/SDIR_Simulator#AdditionalCompetencyProperties',
  Confirmation = 'https://www.sdir.no/SDIR_Simulator#BekreftelseProperties',
  Declaration = 'https://www.sdir.no/SDIR_Simulator#DeclarationProperties',
  IdCard = 'https://www.sdir.no/SDIR_Simulator#IdCardProperties',
  ProfilePicture = 'https://www.sdir.no/SDIR_Simulator#ProfilePictureProperties',
  Signature = 'https://www.sdir.no/SDIR_Simulator#SignatureProperties',
  Other = 'https://www.sdir.no/SDIR_Simulator#OtherProperties',
  ApplicationServiceOther = 'https://www.sdir.no/SDIR_ApplicationService#OtherProperties',
}
